module.exports = __webpack_public_path__ + "static/media/pikashopbymedianara.25bf934d.png";